import { useQuery } from "@tanstack/react-query";

import { listScheduleSnapshots } from "@/stores/pm/repository";

/** One building project's saved snapshots, newest first. Payloads excluded. */
export function useScheduleSnapshots(buildingProjectId: number | null) {
  return useQuery({
    queryKey: ["pm-schedule-snapshots", buildingProjectId],
    queryFn: () => listScheduleSnapshots(buildingProjectId as number),
    enabled: buildingProjectId != null,
    staleTime: 30_000,
  });
}
